import React from "react";

import "./privacy.css"

import { ScrollToTopOnMount } from "../../../../components/scrollToTop/scrollToTop";

const BloodGasPrivacyPolicy = () => {
  ScrollToTopOnMount();
  return (
    <div className="page-main-wrapper Bloodgas-privacy-main-wrapper f-wrp">
      <div className="page-main-wrapper privacy-main-wrapper f-wrp">
        <div className="container">
          
          <div className="abt-cont-wrp f-wrp">
            <h1 className="abt-main-header">Privacy Policy</h1>
            <label></label>
            <p/>
            <p>Effective Date: January 29, 2026</p><br />
            <p>This Privacy Policy describes how the mobile application developed by Dr. Daniel Batlle (the “App”) handles information.</p>
            <br />
            
            
            <label>1. Overview</label>
            <p>The App is a medical calculation tool designed to assist healthcare professionals by converting venous blood gas (VBG) values into arterial blood gas (ABG) values, or vice versa.</p>
            <p>The App does not require user accounts, authentication, or user profiles.</p>
            <br />
            <label>2. Information We Collect</label>
            <p>We do not collect, store, or retain any personal data.</p>
            <p>Specifically:</p>
            <br />
            <ul>
              <li>No names, emails, phone numbers, or identifiers are collected.</li>
              <li>No sign-in or user accounts are required.</li>
              <li>No patient-identifiable information is stored or retained.</li>
              <li>No health records or protected health information (PHI) are collected.</li>
              <li>No location data is accessed.</li>
              <li>No contacts, photos, or files are accessed.</li>
            </ul>
            <br />
            <label>3. Health and Clinical Data</label>
            <p>The App does not store, log, or retain any health data.</p>
            <p>Values entered into the App (such as blood gas parameters) are used only to perform the requested calculation and are not saved, logged, or associated with any user or device.</p>
            <br />
            <label>4. Backend Processing</label>
            <p>Some calculations may occur via backend processing solely to perform the requested computation.</p>
            <ul>
              <li>Data sent for calculation is not stored</li>
              <li>Data is not logged</li>
              <li>Data is not linked to any user, device, or identifier</li>
              <li>Data is discarded immediately after the calculation is completed</li>
              <li>No databases containing user or patient data are maintained.</li>
            </ul>
            <br />
            <label>5. Third-Party Services</label>
            <p>The App does not use:</p>
            <ul>
              <li>Advertising SDKs</li>
              <li>Analytics or tracking services</li>
              <li>Data brokers or marketing platforms</li>
              <li>No data is shared with third parties.</li>
            </ul>
            <br />
            <label>6. Cookies and Tracking Technologies</label>
            <p>The App does not use cookies, tracking pixels, or similar technologies.</p>
            <br />
            <label>7. Data Sharing</label>
            <p>Because no personal or health data is collected or retained, no data is shared with any third party.</p>
            <br />
            <label>8. Data Security</label>
            <p>The App is designed to minimize data exposure by avoiding persistent storage of any user or patient information.</p>
            <p>Any data processed for calculations is transient and discarded immediately after use.</p>
            <br />
            <label>9. Intended Use Disclaimer</label>
            <p>The App is intended as a clinical support tool for trained healthcare professionals.</p>
            <p>It does not replace clinical judgment, laboratory testing, or professional medical advice.</p>
            <br />
            <label>10. Children’s Privacy</label>
            <p>The App is not directed toward children and does not knowingly collect data from anyone under the age of 13.</p>
            <br />
            <label>11. Changes to This Privacy Policy</label>
            <p>This Privacy Policy may be updated from time to time. Any changes will be reflected in the App Store listing or accompanying documentation.</p>
            <br />
            <label>12. Contact Information</label>
            <p>For questions regarding this Privacy Policy:</p>
            <br />
            <p style={{ lineHeight: '1.6' }}>
              Daniel Batlle, MD,<br />
              Professor of Medicine Northwestern University Feinberg School of Medicine.<br />
              Chicago, IL USA.<br />
              <a style={{ color: 'var(--nav-text)' }} href="mailto:d-batlle@northwestern.edu">d-batlle@northwestern.edu</a>
            </p>



          </div>
          
        </div>
      </div>

    </div>
  );
};

export default BloodGasPrivacyPolicy;
